import { SIGN_UP_URL } from './constants';

export type ResultStatus = 'success' | 'no_results' | 'error';

/**
 * Push `${prefix}_${name}` to the GTM dataLayer. No prefix, no tracking.
 * Tracking failures (e.g. a host script replacing `push` with one that throws)
 * are swallowed so they can never break the calculator.
 */
export function pushEvent(prefix: string | undefined, name: string, params?: Record<string, unknown>): void {
  if (!prefix) return;
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: `${prefix}_${name}`, ...params });
  } catch {
    // Intentionally ignored: analytics must not affect the user flow.
  }
}

/** 404 and 422 mean the channel has no usable data; everything else is an error. */
export function resultStatusFromError(status: number): Exclude<ResultStatus, 'success'> {
  return status === 404 || status === 422 ? 'no_results' : 'error';
}

/** Sign-up link, with `?signup_ref=` appended when a ref is given. */
export function buildSignUpUrl(signupRef?: string): string {
  if (!signupRef) return SIGN_UP_URL;
  const url = new URL(SIGN_UP_URL);
  url.search = new URLSearchParams({ signup_ref: signupRef }).toString();
  return url.toString();
}
